/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "./P2PMainComp.css";
import styles from "./P2PMainComp.module.css";
import DomainTile from "../../components/DomainTile/DomainTile";
import BarLineChart from "../../atomicComponents/BarLineChart/BarLineChart";
import DashboardSection from "./DashboardSection";
import axios from "axios";
import config from "../../config/config";
import { setQuarter } from "date-fns";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Marquee from "react-fast-marquee";

function AccountPayableComp() {
  const location = useLocation();
  const history = useHistory();

  const token = localStorage.getItem('ApiToken');

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    monthData: null,
    quarterData: null,
    entityList: null,
    yearList: null,
    monthList: null,
  };

  const quarterOptionss = [
    // { value: "undefined", label: "Select" },
    // { value: "0", label: "-All-" },
    { value: "2", label: "Q1" },
    { value: "3", label: "Q2" },
    { value: "4", label: "Q3" },
    { value: "1", label: "Q4" },
  ];

  const monthOptionss = [
    { value: "1", label: "Jan" },
    { value: "2", label: "Feb" },
    { value: "3", label: "Mar" },
    { value: "4", label: "Apr" },
    { value: "5", label: "May" },
    { value: "6", label: "Jun" },
    { value: "7", label: "Jul" },
    { value: "8", label: "Aug" },
    { value: "9", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
  ];

  const quarterToMonths = {
    2: ["4", "5", "6"], // Apr–Jun
    3: ["7", "8", "9"], // Jul–Sep
    4: ["10", "11", "12"], // Oct–Dec
    1: ["1", "2", "3"], // Jan–Mar
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const { API_BASE_URL } = config;

  const { showPopup } = usePopupManager();

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState(monthOptionss);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);

  const [RefreshedDate, setRefreshedDate] = useState([]);

  const currentDateTime = new Date;
  const yeasterdayDate = new Date(currentDateTime);
  yeasterdayDate.setDate(currentDateTime.getDate()-1);
  const stripedYesterrdayDate = yeasterdayDate.toLocaleDateString();

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [quarter, setQuarter] = useState([]);

  const [InvoiceMaterialData, setInvoiceMaterialData] = useState([]);
  const [InvoiceServicesData, setInvoiceServicesData] = useState([]);
  const [VendorQueriesData, setVendorQueriesData] = useState([]);
  const [VendorReconData, setVendorReconData] = useState([]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "20px",
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: "visible",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }),
    option: (provided) => ({
      ...provided,
      padding: "8px 12px",
    }),
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-entity-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setEntityOptions(response.data[0].all);
        });
    } catch (error) {
      console.error("Error fetching finance-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-year-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setYearOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-year options:", error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-month-dropdown`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setMonthOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };

  const fetchRefreshedDate = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/P2P-Refreshed-Date`, {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setRefreshedDate(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };
  
  const fetchInvoiceMaterialData = async () => {
    const entityval = entity?.value;
    // const entityval = initialFilters.entityData.value;
    // const yearval = Array.isArray(year)? year.map((item) => item?.value): [];
    const yearval = filters?.yearData?.value || year?.value;
    // const monthval = month?.map((item) => item?.value);
    const monthval = Array.isArray(month)? month.map((item) => item?.value): [];
    const quarterval = quarter?.value;
    setIsLoading(true);
    const axios = require("axios");
    let data = JSON.stringify({
      selectedEntity: entityval,
      selectedYear: yearval,
      selectedQuarter: quarterval,
      selectedMonth: monthval,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_BASE_URL}/api/P2P-InvoiceMaterial_drilldown`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // Authorization: "Basic YWRtaW4xOjEyMw==",
      },
      data: data,
    };

    await axios
      .request(config)
      .then((response) => {
        setInvoiceMaterialData(response.data);
        setIsLoading(false);
        setShowDashboard(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const InvoiceMaterialdatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: InvoiceMaterialData.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.4,
      fill: false,
      pointRadius: 6,
    },
    {
      type: "line",
      label: "Timeliness",
      data: InvoiceMaterialData.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.8,
      fill: false,
      pointRadius: 8,
    },
    {
      type: "bar",
      label: "Within SLA",
      data: InvoiceMaterialData.map((item) => item.withinSLA),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: InvoiceMaterialData.map((item) => item.outsideSLA),
      backgroundColor: "#FF0000",
    },
  ];

  const fetchInvoiceServicesData = async () => {
    const entityval = entity?.value;
    // const entityval = initialFilters.entityData.value;
    // const yearval = Array.isArray(year)? year.map((item) => item?.value): [];
    const yearval = filters?.yearData?.value || year?.value;
    // const monthval = month?.map((item) => item?.value);
    const monthval = Array.isArray(month)? month.map((item) => item?.value): [];
    const quarterval = quarter?.value;
    setIsLoading(true);
    const axios = require("axios");
    let data = JSON.stringify({
      selectedEntity: entityval,
      selectedYear: yearval,
      selectedQuarter: quarterval,
      selectedMonth: monthval,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_BASE_URL}/api/P2P-InvoiceServices_drilldown`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // Authorization: "Basic YWRtaW4xOjEyMw==",
      },
      data: data,
    };

    await axios
      .request(config)
      .then((response) => {
        setInvoiceServicesData(response.data);
        setIsLoading(false);
        setShowDashboard(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const InvoiceServicesdatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: InvoiceServicesData.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.4,
      fill: false,
      pointRadius: 6,
    },
    {
      type: "line",
      label: "Timeliness",
      data: InvoiceServicesData.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.8,
      fill: false,
      pointRadius: 8,
    },
    {
      type: "bar",
      label: "Within SLA",
      data: InvoiceServicesData.map((item) => item.withinSLA),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: InvoiceServicesData.map((item) => item.outsideSLA),
      backgroundColor: "#FF0000",
    },
  ];

  const fetchVendorQueriesData = async () => {
    const entityval = entity?.value;
    // const entityval = initialFilters.entityData.value;
    // const yearval = Array.isArray(year)? year.map((item) => item?.value): [];
    const yearval = filters?.yearData?.value || year?.value;
    // const monthval = month?.map((item) => item?.value);
    const monthval = Array.isArray(month)? month.map((item) => item?.value): [];
    const quarterval = quarter?.value;
    setIsLoading(true);
    const axios = require("axios");
    let data = JSON.stringify({
      selectedEntity: entityval,
      selectedYear: yearval,
      selectedQuarter: quarterval,
      selectedMonth: monthval,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_BASE_URL}/api/P2P-VendorQueries_drilldown`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // Authorization: "Basic YWRtaW4xOjEyMw==",
      },
      data: data,
    };

    await axios
      .request(config)
      .then((response) => {
        setVendorQueriesData(response.data);
        setIsLoading(false);
        setShowDashboard(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const VendorQueriesdatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: VendorQueriesData.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.4,
      fill: false,
      pointRadius: 6,
    },
    {
      type: "line",
      label: "Timeliness",
      data: VendorQueriesData.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.8,
      fill: false,
      pointRadius: 8,
    },
    {
      type: "bar",
      label: "Within SLA",
      data: VendorQueriesData.map((item) => item.withinSLA),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: VendorQueriesData.map((item) => item.outsideSLA),
      backgroundColor: "#FF0000",
    },
  ];

  const fetchVendorReconData = async () => {
    const entityval = entity?.value;
    // const entityval = initialFilters.entityData.value;
    // const yearval = Array.isArray(year)? year.map((item) => item?.value): [];
    const yearval = filters?.yearData?.value || year?.value;
    // const monthval = month?.map((item) => item?.value);
    const monthval = Array.isArray(month)? month.map((item) => item?.value): [];
    const quarterval = quarter?.value;
    setIsLoading(true);
    const axios = require("axios");
    let data = JSON.stringify({
      selectedEntity: entityval,
      selectedYear: yearval,
      selectedQuarter: quarterval,
      selectedMonth: monthval,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_BASE_URL}/api/P2P-VendorRecon_drilldown`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        // Authorization: "Basic YWRtaW4xOjEyMw==",
      },
      data: data,
    };

    await axios
      .request(config)
      .then((response) => {
        setVendorReconData(response.data);
        setIsLoading(false);
        setShowDashboard(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const VendorRecondatasets = [
    {
      type: "line",
      label: "Accuracy %",
      data: VendorReconData.map((item) => item.accuracy),
      borderColor: "#90EE90",
      backgroundColor: "#90EE90",
      yAxisID: "y1",
      tension: 0.4,
      fill: false,
      pointRadius: 6,
    },
    {
      type: "line",
      label: "Timeliness",
      data: VendorReconData.map((item) => item.timeliness),
      borderColor: "#800080",
      backgroundColor: "#800080",
      yAxisID: "y1",
      tension: 0.8,
      fill: false,
      pointRadius: 8,
    },
    {
      type: "bar",
      label: "Within SLA",
      data: VendorReconData.map((item) => item.withinSLA),
      backgroundColor: "#0072CE",
    },
    {
      type: "bar",
      label: "Outside SLA",
      data: VendorReconData.map((item) => item.outsideSLA),
      backgroundColor: "#FF0000",
    },
  ];

  const hasRedirected = useRef(false);
  const handleApply = () => {
    if (hasRedirected.current) return;

    const entityRouteMap = {
      agratas: "/Procure-To-Pay/Agratas-Main",
      jlr: "/Procure-To-Pay/JLR-Main",
    };

    const entityValue = entity?.value?.toLowerCase();
    const routeKey = Object.keys(entityRouteMap).find((key) =>
      entityValue?.includes(key)
    );

    if (routeKey) {
      hasRedirected.current = true;
      history.push(entityRouteMap[routeKey], {
        entityData: entity,
        yearData: year,
        quarterData: quarter,
        monthData: month,
      });
    }
    if (Array.isArray(entity) && entity.length === 0) {
      // nothing selected
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    if (Array.isArray(year) && year.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    if (entity?.value) {
      fetchInvoiceMaterialData();
      fetchInvoiceServicesData();
      fetchVendorQueriesData();
      fetchVendorReconData();
    } else {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
    }
  };
  useEffect(() => {
    hasRedirected.current = false;
  }, [entity]);

  const handleEntityChange = (selected) => {
    if (selected) {
      setEntity(selected); // only value
      setFilters((prev) => ({ ...prev, entityData: selected }));
    } else {
      setEntity([]); // reset when cleared
    }
  };

  const handleYearChange = (selected) => {
    if (selected) {
      setYear(selected);
      setFilters((prev) => ({ ...prev, yearData: selected }));
    } else {
      setYear([]);
    }
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleMonthChange = (selected) => {
    if (selected && selected.length > 0) {
      // store array of values like [1,2,3]
      setMonth(selected);
      setFilters((prev) => ({ ...prev, monthData: selected }));
    } else {
      setMonth([]);
    }
  };

  // const handleQuarterChange = (selected) => {
  //   if(selected){
  //     setQuarter(selected);
  //     setFilters(prev => ({ ...prev, quarterData: selected }));
  //   } else {
  //     setQuarter([])
  //   }

  //   if (selected?.value) {
  //     setMonth(
  //       monthOptions.filter((m) =>
  //         quarterToMonths[selected.value].includes(m.value)
  //       )
  //     );
  //     setFilters(prev => ({
  //       ...prev,
  //       monthData: monthOptions.filter(m =>
  //         quarterToMonths[selected?.value]?.includes(m.value) // Safe access
  //       )
  //     }));
  //   } else {
  //     setMonth([]);
  //   }
  //   // setFilters(prev => ({ ...prev, entityData: selected }));
  // };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters((prev) => ({ ...prev, quarterData: selected }));

      const selectedMonths = selected.flatMap(
        (q) => quarterToMonths[q.value] || []
      );
      const filteredMonths = monthOptionss.filter((m) =>
        selectedMonths.includes(m.value)
      );
      setMonth(filteredMonths);
      setFilters((prev) => ({ ...prev, monthData: filteredMonths }));
    } else {
      setQuarter([]);
      setMonth([]);
      setFilters((prev) => ({
        ...prev,
        quarterData: [],
        monthData: [],
      }));
    }
  };
  const handleReset = () => {
    setShowDashboard(false);
    setEntity(null);
    setYear(null);
    setMonth(null);
    setQuarter(null);
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    fetchMonthOptions();
    fetchRefreshedDate();
    // fetchQuarterOptions();
  }, []);

  useEffect(() => {
    // console.log("test log -------------->",entityOptions.length, geographyOptions.length, yearOptions.length, monthOptions.length);
    // console.log("check roles data ----------------->", roles);
    if (
      entityOptions.length &&
      yearOptions.length &&
      monthOptions.length &&
      quarterOptions.length
    ) {
      if (filters.entityData) {
        const ent = entityOptions.find(
          (opt) => opt.value === filters.entityData.value
        );
        if (ent) setEntity(ent);
      }

      if (filters.yearData) {
        const yr = yearOptions.find(
          (opt) => opt.value === filters.yearData.value
        );
      //   const yr = yearOptions.filter((opt) =>
      //   filters.yearData.some((m) => m.value === opt.value)
      // );
        if (yr) {
          setYear(yr);
          // shouldApply = true;
        }
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptionss.filter((opt) =>
          filters.monthData.some((m) => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }
      if (filters.quarterData && filters.quarterData.length > 0) {
        const qtr = quarterOptionss.filter((opt) =>
          filters.quarterData.some((m) => m.value === opt.value)
        );
        if (qtr.length > 0) setQuarter(qtr);
      }

      setHasApplied(true);
    }
  }, [entityOptions, yearOptions, monthOptions, quarterOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>
              Entity <span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Fiscal Year
            <span style={{ color: "red" }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                // isMulti={true}
                isSearchable={true}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                // onChange={setQuarter}
                onChange={handleQuarterChange}
                options={quarterOptionss}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptionss}
                isSearchable={true}
                isMulti={true}
                styles={customStyles}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="text-center">
            <div
              className="spinner-border text-primary mb-3"
              role="status"
            ></div>
            <p
              className="mb-3"
              style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}
            >
              Loading...
            </p>
          </div>
        </div>
      )}

      {showDashboard && (
        <div>
          <div className="row">
            <div className="col-md-12">
              <DomainTile
                title="Accounts Payables"
                showBackButton={true}
                mainPagePath="/Procure-To-Pay/Account-Payable"
                detailState={filters}
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-6 mb-1">
              <DashboardSection
                title="Invoice Verification (Material)"
                disableDetailView={true}
                detailPath="/Procure-To-Pay"
                disableInfoIcon={false}
                popupContent="Manual CSV DATA"
              >
                <BarLineChart
                  datasets={InvoiceMaterialdatasets}
                  chartData={InvoiceMaterialData}
                  height={250}
                />
              </DashboardSection>
            </div>
            <div className="col-lg-6 mb-1">
              <DashboardSection
                title="Invoice Verification (Services)"
                disableDetailView={true}
                detailPath="/Procure-To-Pay"
                disableInfoIcon={false}
                popupContent="Manual CSV DATA"
              >
                <BarLineChart
                  datasets={InvoiceServicesdatasets}
                  chartData={InvoiceServicesData}
                  height={250}
                />
              </DashboardSection>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 mb-1">
              <DashboardSection
                title="Vendor Queries"
                disableDetailView={true}
                detailPath="/Procure-To-Pay"
                disableInfoIcon={false}
                popupContent="Manual CSV DATA"
              >
                <BarLineChart
                  datasets={VendorQueriesdatasets}
                  chartData={VendorQueriesData}
                  height={250}
                />
              </DashboardSection>
            </div>
            <div className="col-lg-6">
              <DashboardSection
                title="Vendor Reconciliations"
                disableDetailView={true}
                detailPath="/Procure-To-Pay"
                disableInfoIcon={false}
                popupContent="Manual CSV DATA"
              >
                <BarLineChart
                  datasets={VendorRecondatasets}
                  chartData={VendorReconData}
                  height={250}
                />
              </DashboardSection>
            </div>
          </div>
          <div className="row" style={{fontSize:"12px", color:"red"}}>
          <Marquee speed={30} gradient={false}>
          Last Refresh Date:- <b>{stripedYesterrdayDate}</b>
          </Marquee>
        </div>
        </div>
      )}
    </>
  );
}

export default AccountPayableComp;
